import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { openWindow } from '../../../services/openWindow';
import { ILink } from '../../../types/link';

export default class DriverNumber extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field) return null;

    return (
      <td {...this.props.tdProps}>
        <a
          href="#"
          style={{ color: '#007bff' }}
          title={this.props.dataItem.DispatchNote}
          onClick={(e) => {
            openWindow(this.props.dataItem.Links.filter((x: ILink) => x.Name === 'DriverProfile')[0].Link);
            e.preventDefault();
          }}
        >
          {this.props.dataItem.DriverNumber} {this.props.dataItem.IsNewHire && <span className="badge badge-warning">NEW</span>}
        </a>
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
  }
}
